"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dialogModeContext = exports.DialogModeProvider = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const dialogModeContext = exports.dialogModeContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const {
  Provider
} = dialogModeContext;
const DialogModeProvider = ({
  children,
  value
}) => {
  const [mode, setMode] = (0, _react.useState)(value);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: (0, _react.useMemo)(() => ({
      mode,
      setMode
    }), [mode]),
    children: children
  });
};
exports.DialogModeProvider = DialogModeProvider;
